import React from 'react';
import PropTypes from 'prop-types';
import { IconTrash } from '../../../assets/images';
import { useLanguage } from '../../../localization/useLanguage';

const CallLogHeader = ({
    dataLength,
    isSelectionMode,
    selectedCount,
    totalCount,
    onSearchChange,
    onToggleSelectionMode,
    onSelectAllToggle,
    onDeleteSelected,
}) => {
    const { t } = useLanguage();

    return (
        <div className="call-log-header-container">
            <div className="recent-chatlist-header">
                <h3 className="ting_tittle">{t('calls.LOGS.CALL_LOGS')}</h3>
                <div className="profile-options">
                    {dataLength > 0 && (
                        <button
                            className="ct-btn-text ct-cursor"
                            onClick={onToggleSelectionMode}
                            style={{
                                color: '#007bff',
                                background: 'none',
                                border: 'none',
                                fontSize: '14px',
                                fontWeight: '500',
                            }}
                        >
                            {isSelectionMode ? t('calls.LOGS.CANCEL') : t('calls.LOGS.CLEAR_CALL_LOG')}
                        </button>
                    )}
                </div>
            </div>

            {isSelectionMode && (
                <div
                    className="callScreenSelectionHeader"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        padding: '12px 16px',
                        background: '#fff5f5',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <div className="callScreenCheckbox abs-checkbox">
                            <input
                                type="checkbox"
                                checked={selectedCount === totalCount && totalCount > 0}
                                onChange={onSelectAllToggle}
                            />
                        </div>
                        <span className="callScreenSelectionCount" style={{ color: '#f44336', fontWeight: '500' }}>
                            {selectedCount === totalCount && totalCount > 0 ? (
                                t('calls.LOGS.SELECTED_ALL')
                            ) : (
                                <>
                                    <span>{selectedCount}</span> {t('calls.LOGS.SELECTED')}
                                </>
                            )}
                        </span>
                    </div>
                    {selectedCount > 0 && (
                        <button
                            type="button"
                            className="callScreenDeleteBtn"
                            onClick={() => {
                                onDeleteSelected();
                            }}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                background: '#f44336',
                                color: 'white',
                                border: 'none',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                        >
                            <i className="ct-icon sm">
                                <IconTrash />
                            </i>
                            <span>{t('calls.LOGS.DELETE')}</span>
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

CallLogHeader.propTypes = {
    dataLength: PropTypes.number,
    isSelectionMode: PropTypes.bool,
    selectedCount: PropTypes.number,
    totalCount: PropTypes.number,
    onSearchChange: PropTypes.func,
    onToggleSelectionMode: PropTypes.func,
    onSelectAllToggle: PropTypes.func,
    onDeleteSelected: PropTypes.func,
};

export default React.memo(CallLogHeader);
